import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "search-page-search-bar-dropdown-component"
}
const _hoisted_2 = {
  key: 1,
  class: "search-page-search-bar-dropdown-component"
}

import { computed, onMounted } from "vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";
import SearchPageSearchBarDropdownResult from "@/components/v2/search-page/SearchPageSearchBarDropdownResult.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageSearchBarDropdownResults',
  props: {
  pageName: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const searchPageStore = useSearchPageStore();

const props = __props;

const dataDropdown = computed(
  () => searchPageStore.searchPageState.dataDropdown
);

const recentlyViewedItems = computed(
  () => searchPageStore.searchPageState.recentlyViewed
);

const showDropdownResults = computed<boolean>(
  () =>
    searchPageStore.searchPageState.search.typing &&
    searchPageStore.searchPageState.search.typing.length >= 3 &&
    searchPageStore.searchPageState.search.focus
);

const showRecentlyViewedResults = computed<boolean>(
  () =>
    (searchPageStore.searchPageState.search.typing &&
      searchPageStore.searchPageState.search.typing.length < 3 &&
      searchPageStore.searchPageState.search.focus) ||
    (!searchPageStore.searchPageState.search.typing &&
      searchPageStore.searchPageState.search.focus)
);

onMounted(() => {
  searchPageStore.getRecentlyViewedPages();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showDropdownResults.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataDropdown.value, (dropdownItem) => {
            return (_openBlock(), _createBlock(SearchPageSearchBarDropdownResult, {
              class: "searchbar-dropdown-item",
              pageName: __props.pageName,
              key: dropdownItem.id,
              result: dropdownItem
            }, null, 8, ["pageName", "result"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!showDropdownResults.value && _unref(searchPageStore).searchPageState.search.focus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("nav", null, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "searchbar-dropdown-item-title" }, "Recently Viewed", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentlyViewedItems.value, (dropdownItem) => {
              return (_openBlock(), _createBlock(SearchPageSearchBarDropdownResult, {
                class: "searchbar-dropdown-item",
                pageName: __props.pageName,
                key: dropdownItem.id,
                result: dropdownItem
              }, null, 8, ["pageName", "result"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})